export const escapeForRegExp = (query: string): string => {
  return query.replace(/[-\\^$*+?.()|[\]{}]/g, "\\$&");
};
